import React, { useState } from 'react'
import { ServerErrorProps } from './ServerError.types'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

export function ServerError({ message, code, onClose }: ServerErrorProps) {
  const [showModal, setModal] = useState(true)

  function onToggle() {
    setModal(_ => !_)
    if (showModal && onClose) {
      onClose()
    }
  }

  if (!showModal) {
    return null
  }

  return (
    <>
      <Modal isOpen toggle={onToggle}>
        <ModalHeader toggle={onToggle}>Error</ModalHeader>
        <ModalBody>
          <div className="text-center">
            <div>
              <i className="fa fa-exclamation-triangle fa-4x text-danger" />
            </div>
            <h5>There was a problem and your request could not be completed at this time.</h5>
            {message && <p>{message}</p>}
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-light" onClick={onToggle}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  )
}
